// extracted by mini-css-extract-plugin
export default {"LoginImageContainer":"Login_styles_LoginImageContainer__mkLzz","LoginCentre":"Login_styles_LoginCentre__HmNLY"};